import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, connect } from "react-redux";
import { setActivePage } from "../redux/actions/appSettingsActions";
import { setActiveLanguage } from "../redux/actions/appSettingsActions";
import {
  fetchAdressDetailsSuccess,
  fetchAddressDetailsFailure,
} from "../redux/reducers/addressDetailsReducer";
import {
  fetchAddressResultRequest,
  fetchAddressResultSuccess,
} from "../redux/actions/addressingResultActions";
import { getAddressByHashkey } from "../serviceClients/addressingClient";
import { useTranslation } from "react-i18next";

import {
  addressDetailsMapper,
  addressingApiResponseMapper,
} from "./mappers/addressingMappers";

const ShowAddress = (props) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation("uaePassPage");

  const store_appToken =
    props.appSettings &&
    props.appSettings.userCredentials &&
    props.appSettings.userCredentials.token
      ? props.appSettings.userCredentials.token.access_token
      : null;
  useEffect(() => {
    if (getQueryVariable("p")) {
      const addressId = getQueryVariable("p");
      const language = getQueryVariable("lang");
      dispatch(setActiveLanguage(language));
      i18n.changeLanguage(language);
      dispatch(setActivePage("Map"));
      getAddressResultByHashKey(addressId);
    }
  }, []);

  const getAddressResultByHashKey = (key) => {
    if (!props.isAddressPanelOpen) props.openAddressPanel();
    dispatch(fetchAddressResultRequest("Suggestion_Select", key));
    const [promise, source] = getAddressByHashkey(key, store_appToken);
    promise
      .then((resp) => {
        const {
          isSuccess,
          isPartial,
          message,
          respData,
          successObj,
          failedObj,
        } = addressingApiResponseMapper(resp.data);
        if (isSuccess) {
          console.log(respData);
          var candidates = addressDetailsMapper(respData);
          dispatch(fetchAddressResultSuccess([]));
          dispatch(fetchAdressDetailsSuccess(candidates));
          history.push("/Map");
        } else {
          dispatch(fetchAddressDetailsFailure(message));
        }
      })
      .catch((err) => {
        console.log("Coundnt Fetch Address Detail ", err.message);
        const errMsg = err.message;
        dispatch(fetchAddressDetailsFailure(errMsg));
      });
  };

  const getQueryVariable = (variable) => {
    var query = window.location.search.substring(1);
    console.log(query); //"app=article&act=news_content&aid=160990"
    var vars = query.split("&");
    console.log(vars); //[ 'app=article', 'act=news_content', 'aid=160990' ]
    for (var i = 0; i < vars.length; i++) {
      var pair = vars[i].split("=");
      console.log(pair); //[ 'app', 'article' ][ 'act', 'news_content' ][ 'aid', '160990' ]
      if (pair[0] == variable) {
        return pair[1];
      }
    }
    return false;
  };

  return <></>;
};

const mapStateToProps = (state) => {
  return {
    isAddressPanelOpen:
      state.mapPanelSetting.isSidePanelOpen &&
      state.mapPanelSetting.resultType === "address",
    appSettings: state.settings,
  };
};

export default connect(mapStateToProps, null)(ShowAddress);
